import React,{useState,useEffect} from 'react'
import {plansData} from '../../data/plansData'
import whiteTick from '../../assets/whiteTick.png'
import './Plans.css'
import { useNavigate } from 'react-router-dom'
import {Api} from "../../Api.js"
import { createOrderPackage, VerifyPayment } from '../../Services/Operations/ProductAPI.js'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'

const Plans = () => {
    const navigate = useNavigate();
    const [packageData,SetPackageData] = useState([])
     const { isAuthenticated,token} = useSelector((state) => state.auth);

    useEffect(()=>{
        const fetchPackage = async()=>{
            try{
                const response = await Api.get("/burnout-gym-package");
                console.log("Backend gym package: ", response.data);

                if(response.data.status === true){
                    SetPackageData(response.data.data);
                }

            }catch(err){
                console.log(err);
            }
        }
        fetchPackage();
    },[])


    const handleOrderPackage=async(id)=>{
        try {
            let data={
                package_id:id
            }
            if(!token){
                navigate("/login")
                return
            }
            const res=await createOrderPackage(data,token)
            console.log('createOrderPackage',res);
            if(res.status==200){
                handlePayment(res.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }

          const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const verifyPayment=async(data)=>{
try {
  if(!token){
     toast.warning("Unauthorized login first")
        navigate("/login")
  }
  console.log(data);
  const res= await VerifyPayment(data,token)
 console.log(res);
  if(res.status===200){
    toast.success(
"Payment successful & property booked")
  }
  
  
} catch (error) {
  console.log(error);
  
}
}


  const handlePayment = async (data) => {
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Razorpay SDK failed to load");
      return;
    }

    // Call your backend to create order
    // const data = await fetch("/api/create-order", {
    //   method: "POST",
    // }).then((t) => t.json());

    console.log("total fees",data.total_amount);
    

    const options = {
      key: data.key, // from Razorpay dashboard
      amount: data.total_amount,
      currency: "INR",
      name: "Siance Software",
      description: "Test Transaction",
      order_id: data.order_id,

      handler: function (response) {
        console.log("Payment Success:", response);
         verifyPayment(response)
        // send this response to backend for verification
        // response.razorpay_payment_id
        // response.razorpay_order_id
        // response.razorpay_signature
      },
 
      prefill: {
        name: "John Doe",
        email: "john@example.com",
        contact: "9999999999",
      },

      theme: {
        color: "#3399cc",
      },
    };

   

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  return (
    <div className="plans-container">
        <div className="blur plans-blur-1"></div>
        <div className="blur plans-blur-2"></div>

        <div className="programs-header" style={{gap: '2rem'}}>
            <span className="stroke-text">READY TO START</span>
            <span>YOUR JOURNEY</span>
            <span className="stroke-text">NOW WITH US</span>   
        </div>

        <div className="plans">
            {plansData.map((plan, index) => {

                const backend = packageData[index]; // MATCHING BY INDEX

                return (
                    <div className="plan" key={index}>
                        {plan.icon}
                        <span>{backend?.package_name || plan.name}</span>

                        <span>₹ {backend?.price || plan.price}</span>
                        <p>₹  {backend?.admission_fee || plan.admission_fee}(Admission fee)</p>
                         <span>Duration Per Day: {backend?.duration} Hours</span>
                        <div className="features">
                            {(backend?.features || plan.features)?.map((feature, i) => (
                                <div className="feature" key={i}>
                                    <img src={whiteTick} alt="" />
                                   
                                    <span>{feature}</span>
                                </div>
                            ))}
                        </div>

                        <div>
                            <span>See more benefits →</span>
                        </div>

                        <button className="btn" onClick={()=>handleOrderPackage(backend.id)}>
                            Join now
                        </button>
                    </div>
                )
            })}
        </div>
    </div>
  )
}

export default Plans
